'use client';

import { useEffect } from 'react';
import { ErrorPage } from '@rv-life/design-system';
import { notifyBugsnag } from '@/utils/bugsnag';

const Error = ({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) => {
	useEffect(() => {
		// eslint-disable-next-line no-console
		console.log('Errorboundary has caught an error:', { error });
		notifyBugsnag(error);
	}, [error]);

	return <ErrorPage onHomeLinkClick={reset} onRefresh={() => window.location.reload()} />;
};

export default Error;
